import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { AntennaLogo } from "./AntennaLogo";

const links = [
  { label: "Benefícios", href: "#beneficios" },
  { label: "Planos", href: "#planos" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#05050A]/70 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-8">
        <button onClick={() => go("#topo")} data-testid="logo-btn" className="flex items-center gap-2">
          <AntennaLogo className="h-6 w-6" />
          <span className="font-display text-xl font-black tracking-tighter">
            NOVA<span className="text-[#8B5CF6]">STREAM</span>
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="font-body text-sm text-slate-300 transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="header-cta"
            onClick={() => go("#planos")}
            className="rounded-full border-2 border-[#8B5CF6] px-5 py-2 font-display text-sm font-bold text-white transition-colors hover:bg-[#8B5CF6]"
          >
            Ver Planos
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-b border-white/5 bg-[#05050A]/95 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col gap-1 px-4 py-4">
              {links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`mobile-nav-${l.href.slice(1)}`}
                  onClick={() => go(l.href)}
                  className="rounded-lg px-3 py-3 text-left font-body text-slate-200 hover:bg-white/5"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="mobile-header-cta"
                onClick={() => go("#planos")}
                className="mt-2 rounded-full bg-[#8B5CF6] px-5 py-3 font-display font-bold text-white"
              >
                Ver Planos
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
